<ng-content></ng-content>

<cm-inspector-section>
    <ng-container cm-title> Blend Material Slot </ng-container>
    <ng-container cm-content>
        <cm-value-slot [node]="$node()" [key]="'material'" [label]="'Material'"></cm-value-slot>
        <cm-value-slot [node]="$node()" [key]="'image'" [label]="'Image'"></cm-value-slot>
        <cm-value-slot [node]="$node()" [key]="'slot'" [label]="'Slot'" [selectionPossibilities]="$slotPossibilities()"></cm-value-slot>
        <cm-value-slot
            [node]="$node()"
            [key]="'blendAmount'"
            [label]="'Amount'"
            [numberModifier]="'slider'"
            [min]="0"
            [max]="1"
            [decimalPlaces]="2"
        ></cm-value-slot>
        <cm-value-slot [node]="$node()" [key]="'uvChannel'" [label]="'UV Channel'" [decimalPlaces]="0"></cm-value-slot>
        <cm-value-slot [node]="$node()" [key]="'size'" [subKey]="0" [label]="'Width'"></cm-value-slot>
        <cm-value-slot [node]="$node()" [key]="'size'" [subKey]="1" [label]="'Height'"></cm-value-slot>
    </ng-container>
</cm-inspector-section>
